
import {
  defineComponent,
} from 'vue';

import TelaPadraoCrud from '@/core/components/TelaPadraoCrud.vue';
import { useCrudBase } from '@/core/composables/CrudBase';
import PermissaoModal from '@/views/PainelAdministrativo/Permissoes/PermissaoModal.vue';
import ServicoPermissao from '@/servicos/PainelAdministrativo/Permissoes/ServicoPermissao';
import { ECustomRenderRow } from '@/core/models/AntDesign/IColumn';
import { IOrdenacao } from '@/core/models/Consulta/IOrdenacao';

export default defineComponent({
  name: 'Permissao',
  components: {
    TelaPadraoCrud,
    PermissaoModal,
  },
  setup() {
    const {
      crudBase, preencherEstrutura, exibirModal, sincronizaTelaCrud,
    } = useCrudBase();
    const servicoPermissao = new ServicoPermissao();

    crudBase.estrutura = preencherEstrutura();
    crudBase.estrutura.apresentarEmpresas = false;
    crudBase.estrutura.verificarCadastroCompartilhado = false;
    crudBase.estrutura.botaoPrincipalAcao = 'Nova permissão';
    crudBase.estrutura.mensagemExclusao = 'Você confirma a exclusão da permissão';
    crudBase.estrutura.colunasGrade = [
      {
        title: 'Descrição', dataIndex: 'descricao', key: 'DescricaoPermissao', position: 0, visible: true, ordering: true, fixed: 'left', align: 'left', customRenderRow: ECustomRenderRow.LinkAcao,
      },
      {
        title: 'Código', dataIndex: 'codigo', key: 'CodigoPermissao', position: 1, visible: false,
      },
      {
        title: 'Identificador', dataIndex: 'identificador', key: 'IdentificadorPermissao', position: 2, visible: true, ordering: true, align: 'left',
      },
      {
        title: 'Tipo', dataIndex: 'tipo', key: 'TipoPermissao', position: 3, visible: true, width: 100, ordering: true, align: 'left',
      },
      {
        title: 'Categoria', dataIndex: 'categoria', key: 'CategoriaPermissao', position: 4, visible: true, ordering: true, align: 'left',
      },
      {
        title: 'Ações', key: 'acoes', position: 5, visible: true, fixed: 'right', width: 100, align: 'center', customRenderRow: ECustomRenderRow.IconeAcoes,
      },
    ];
    crudBase.estrutura.ordenacaoPadraoGrade.push({ identificador: 'CodigoPermissao', ordem: 'DESC' } as IOrdenacao);

    return {
      crudBase,
      servicoPermissao,
      exibirModal,
      sincronizaTelaCrud,
    };
  },
});
